<template>
  <b-card :header="`${this.label} no asignados`">
    <Search
      @getVoids="getVoids"
      @searchText="searchText"
      @changeQty="changeQty"
      :void="this.void"
      :file_name="`${this.label}_no_asignados`"
      :filteredRqs="filteredRqs"
      :json_fields="json_fields"
    />
    <div class="table-responsive">
      <table class="table table-bordered table-hover table-striped">
        <thead>
          <tr>
            <th>
              <a href="javscript:void(0)" @click="sort('id')">
                #RQ
                <i
                  v-if="currentSort === 'id'"
                  :class="`fa fa-sort-${currentSortDir === 'asc'? 'up' : 'down'}`"
                ></i>
              </a>
            </th>
            <th v-if="isDev">
              <a href="javscript:void(0)" @click="sort('service.requeriment_id')">
                #RQ Original
                <i
                  v-if="currentSort === 'service.requeriment_id'"
                  :class="`fa fa-sort-${currentSortDir === 'asc'? 'up' : 'down'}`"
                ></i>
              </a>
            </th>
            <th>
              <a href="javscript:void(0)" @click="sort('service.doc_number')">
                {{ isPos ? 'Booking':'BL/BK' }}
                <i
                  v-if="currentSort === 'service.doc_number'"
                  :class="`fa fa-sort-${currentSortDir === 'asc'? 'up' : 'down'}`"
                ></i>
              </a>
            </th>
            <th v-if="isPos">
              <a href="javscript:void(0)" @click="sort('service.owner_name')">
                Embarcador
                <i
                  v-if="currentSort === 'service.owner_name'"
                  :class="`fa fa-sort-${currentSortDir === 'asc'? 'up' : 'down'}`"
                ></i>
              </a>
            </th>
            <th>
              <a href="javscript:void(0)" @click="sort('service.shipping_line.name')">
                Linea naviera
                <i
                  v-if="currentSort === 'service.shipping_line.name'"
                  :class="`fa fa-sort-${currentSortDir === 'asc'? 'up' : 'down'}`"
                ></i>
              </a>
            </th>
            <th v-if="isPos">
              <a href="javscript:void(0)" @click="sort('service.ship_name')">
                Nave
                <i
                  v-if="currentSort === 'service.ship_name'"
                  :class="`fa fa-sort-${currentSortDir === 'asc'? 'up' : 'down'}`"
                ></i>
              </a>
            </th>
            <th v-if="[constants.POSICIONAMIENTOS, constants.DEVOLUCIONES].includes(service_code)">
              <a href="javscript:void(0)" @click="sort('service.company.name')">
                Cliente
                <i
                  v-if="currentSort === 'service.company.name'"
                  :class="`fa fa-sort-${currentSortDir === 'asc'? 'up' : 'down'}`"
                ></i>
              </a>
            </th>
            <th v-if="[constants.POSICIONAMIENTOS, constants.DEVOLUCIONES].includes(service_code)">
              <a href="javscript:void(0)" @click="sort('service.company.company_bill.name')">
                Facturar a
                <i
                  v-if="currentSort === 'service.company.company_bill.name'"
                  :class="`fa fa-sort-${currentSortDir === 'asc'? 'up' : 'down'}`"
                ></i>
              </a>
            </th>
            <th>
              <a href="javscript:void(0)" @click="sort('deposit_pick.name')">
                Depósito de retiro
                <i
                  v-if="currentSort === 'deposit_pick.name'"
                  :class="`fa fa-sort-${currentSortDir === 'asc'? 'up' : 'down'}`"
                ></i>
              </a>
            </th>
            <th>
              <a href="javscript:void(0)" @click="sort('deposit.name')">
                Depósito de entrega
                <i
                  v-if="currentSort === 'deposit.name'"
                  :class="`fa fa-sort-${currentSortDir === 'asc'? 'up' : 'down'}`"
                ></i>
              </a>
            </th>
            <th>
              <a href="javscript:void(0)" @click="sort('date')">
                Fecha de {{isPos ? 'retiro' : 'operación'}}
                <i
                  v-if="currentSort === 'date'"
                  :class="`fa fa-sort-${currentSortDir === 'asc'? 'up' : 'down'}`"
                ></i>
              </a>
            </th>
            <th v-if="service_code === constants.DEVOLUCIONES">
              <a href="javscript:void(0)" @click="sort('container_expiration')">
                Sobre estadía
                <i
                  v-if="currentSort === 'container_expiration'"
                  :class="`fa fa-sort-${currentSortDir === 'asc'? 'up' : 'down'}`"
                ></i>
              </a>
            </th>
            <th v-if="isPos">
              <a href="javscript:void(0)" @click="sort('date_fill')">
                Fecha de llenado
                <i
                  v-if="currentSort === 'date_fill'"
                  :class="`fa fa-sort-${currentSortDir === 'asc'? 'up' : 'down'}`"
                ></i>
              </a>
            </th>
            <th v-if="isPos">
              <a href="javscript:void(0)" @click="sort('service.cutoff')">
                Cutoff
                <i
                  v-if="currentSort === 'service.cutoff'"
                  :class="`fa fa-sort-${currentSortDir === 'asc'? 'up' : 'down'}`"
                ></i>
              </a>
            </th>
            <th>
              <a href="javscript:void(0)" @click="sort('container_number')">
                Contenedor
                <i
                  v-if="currentSort === 'container_number'"
                  :class="`fa fa-sort-${currentSortDir === 'asc'? 'up' : 'down'}`"
                ></i>
              </a>
            </th>
            <th>
              <a href="javscript:void(0)" @click="sort('container_size.name')">
                Tipo de contenedor
                <i
                  v-if="currentSort === 'container_size.name'"
                  :class="`fa fa-sort-${currentSortDir === 'asc'? 'up' : 'down'}`"
                ></i>
              </a>
            </th>
            <th v-if="isPos">
              <a href="javscript:void(0)" @click="sort('inspection')">
                Inspección
                <i
                  v-if="currentSort === 'inspection'"
                  :class="`fa fa-sort-${currentSortDir === 'asc'? 'up' : 'down'}`"
                ></i>
              </a>
            </th>
            <th v-if="isPos">
              <a href="javscript:void(0)" @click="sort('lined')">
                Forrado
                <i
                  v-if="currentSort === 'lined'"
                  :class="`fa fa-sort-${currentSortDir === 'asc'? 'up' : 'down'}`"
                ></i>
              </a>
            </th>
            <th>Solicitante</th>
            <th>Creado el</th>
            <th>
              <a href="javscript:void(0)" @click="sort('status.name')">
                Estado
                <i
                  v-if="currentSort === 'status.name'"
                  :class="`fa fa-sort-${currentSortDir === 'asc'? 'up' : 'down'}`"
                ></i>
              </a>
            </th>
            <th v-if="isPos">Documentos</th>
          </tr>
        </thead>
        <tbody>
          <tr
            v-for="(rq, k) in paginated('filteredRqs')"
            :key="k"
            @contextmenu.prevent="selectRq(rq)"
          >
            <td>{{rq.id}}</td>
            <td v-if="isDev">
              <a
                target="_blank"
                :href="`/requeriments/import/detail/${rq.service.requeriment_id}`"
              >{{rq.service.requeriment_id}}</a>
            </td>
            <td>{{rq.service.doc_number}}</td>
            <td v-if="isPos">{{rq.service.owner_name}}</td>
            <td>{{rq.service.shipping_line ? rq.service.shipping_line.name : ''}}</td>
            <td v-if="isPos">{{rq.service.ship_name}}</td>
            <td
              v-if="[constants.POSICIONAMIENTOS, constants.DEVOLUCIONES].includes(service_code)"
            >{{rq.service.company ? rq.service.company.name : ''}}</td>
            <td
              v-if="[constants.POSICIONAMIENTOS, constants.DEVOLUCIONES].includes(service_code)"
            >{{rq.service.company ? rq.service.company.company_bill.name : ''}}</td>
            <td>{{rq.deposit_pick ? rq.deposit_pick.name : ''}}</td>
            <td>{{rq.deposit? rq.deposit.name : ''}}</td>
            <td>{{rq.date | formatDateTime}}</td>
            <td
              v-if="service_code === constants.DEVOLUCIONES"
            >{{rq.container_expiration | formatDate}}</td>
            <td v-if="isPos">{{rq.date_fill | formatDateTime}}</td>
            <td v-if="isPos">{{rq.service.cutoff | formatDateTime}}</td>
            <td>{{rq.container_number}}</td>
            <td>{{rq.container_size ? rq.container_size.name : ''}}</td>
            <td v-if="isPos">{{rq.inspection ? 'SI' : 'NO'}}</td>
            <td v-if="isPos">{{rq.lined ? 'SI' : 'NO'}}</td>
            <td>
              {{
                rq.service.applicant
                  ? `${rq.service.applicant.name} ${rq.service.applicant.last_name}`
                  : ""
              }}
            </td>
            <td>{{ rq.created_at | formatDateTime }}</td>
            <td>{{rq.status.name}}</td>
            <td v-if="isPos">
              <button
                style="margin-bottom: 5px;"
                @click="openDoc('doc_seal', rq.service.doc_seal)"
                v-if="rq.service.doc_seal"
                class="btn btn-sm btn-primary"
              >
                <i class="fa fa-file" /> Precinto
              </button>&nbsp;
              <button
                @click="openDoc('doc_booking', rq.service.doc_booking)"
                v-if="rq.service.doc_booking"
                class="btn btn-sm btn-primary"
              >
                <i class="fa fa-file" /> Booking
              </button>
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <context-menu id="context-menu" ref="ctxMenu">
      <li v-on:click="showModal=true" class="ctx-item" v-if="$can('assign','Voids')">Asignar</li>
      <li @click="detail()" class="ctx-item">Detalle</li>
      <li @click="edit()" class="ctx-item" v-if="$can('manage','Voids')">Editar contenedor</li>
      <li @click="editService()" class="ctx-item" v-if="isPos && $can('manage','Voids')">Editar servicio</li>
      <li v-on:click="cancel()" class="ctx-item" v-if="$can('manage','Voids')">Anular</li>
      <li v-on:click="finishService()" class="ctx-item" v-if="$can('manage','Voids')">Finalizar</li>
    </context-menu>

    <paginate
      name="filteredRqs"
      :list="filteredRqs"
      class="paginate-list"
      :per="numPages"
      :refreshCurrentPage="false"
    ></paginate>
    <paginate-links
      for="filteredRqs"
      :limit="5"
      :show-step-links="true"
      :step-links="{
        next: '>>',
        prev: '<<'
      }"
      :classes="{
        'ul': 'pagination',
        'li': 'page-item',
        'a': 'page-link',
      }"
    ></paginate-links>

    <ModalTrucks
      :showModal="showModal"
      :requeriment="rq"
      :statuses="statuses"
      @close="showModal = false"
    />
    <ModalSubjects
      :showModalSubjects="showModalSubjects"
      :rq="rq"
      @sendSubjects="sendSubjects"
      @close="showModalSubjects = false"
    />
    <div v-if="showModal || showModalSubjects" class="modal-backdrop fade show"></div>
  </b-card>
</template>

<script>
import api from "@/helpers/api";
import s3 from "@/helpers/aws";
import constants from "@/constants";
import moment from "moment";
import _ from "lodash";
import Search from "./Search";
import contextMenu from "vue-context-menu";
import ModalTrucks from "../ModalTrucks";
import ModalSubjects from "../ModalSubjects";

import redeliveries_fields from "@/helpers/json_fields/redeliveries_fields";
import positionings_fields from "@/helpers/json_fields/positionings_fields";
import devolutions_fields from "@/helpers/json_fields/devolutions_fields";
import { mapGetters } from "vuex";

export default {
  components: { Search, contextMenu, ModalTrucks, ModalSubjects },
  data() {
    return {
      rqs: [],
      rq: { status: {} },
      constants: {},
      json_fields: {},
      statuses: [],
      paginate: ["filteredRqs"],
      numPages: 100,
      search: "",
      date: {
        start: moment(),
        end: moment()
      },
      showModal: false,
      showModalSubjects: false,
      void: this.$route.params.void,
      label: "",
      service_code: "",
      currentSort: "id",
      currentSortDir: "asc"
    };
  },
  computed: {
    ...mapGetters({ user: "user/user" }),
    isPos() {
      return this.service_code === constants.POSICIONAMIENTOS;
    },
    isDev() {
      return this.service_code === constants.DEVOLUCIONES;
    },
    filteredRqs() {
      return this.rqs
        .filter(rq => {
          let condition = ![
            constants.ANULADO_TRAMARSA,
            constants.CANCELADO_CLIENTE,
            constants.DRAFT,
            constants.FINALIZADO
          ].includes(rq.status.code);

          let condition_txt = true;

          if (this.search) {
            const textSearch = this.search.toLowerCase();
            condition_txt = false;

            if (rq.service.doc_number)
              condition_txt =
                condition_txt ||
                rq.service.doc_number.toLowerCase().includes(textSearch);
            if (rq.service.owner_name)
              condition_txt =
                condition_txt ||
                rq.service.owner_name.toLowerCase().includes(textSearch);
            if (rq.service.ship_name)
              condition_txt =
                condition_txt ||
                rq.service.ship_name.toLowerCase().includes(textSearch);
            if (rq.service.company)
              condition_txt =
                condition_txt ||
                rq.service.company.name.toLowerCase().includes(textSearch);
            if (rq.service.company)
              condition_txt =
                condition_txt ||
                rq.service.company.company_bill.name.toLowerCase().includes(textSearch);
            if (rq.deposit)
              condition_txt =
                condition_txt ||
                rq.deposit.name.toLowerCase().includes(textSearch);
            if (rq.deposit_pick)
              condition_txt =
                condition_txt ||
                rq.deposit_pick.name.toLowerCase().includes(textSearch);
            if (rq.container_number)
              condition_txt =
                condition_txt ||
                rq.container_number.toLowerCase().includes(textSearch);
            if (rq.service.shipping_line)
              condition_txt =
                condition_txt ||
                rq.service.shipping_line.name
                  .toLowerCase()
                  .includes(textSearch);
            if (rq.container_size)
              condition_txt =
                condition_txt ||
                rq.container_size.name.toLowerCase().includes(textSearch);
            if (rq.status)
              condition_txt =
                condition_txt ||
                rq.status.name.toLowerCase().includes(textSearch);

            condition_txt = condition_txt || textSearch === rq.id.toString();
          }
          return condition && condition_txt;
        })
        .sort((objA, objB) => {
          let modifier = 1;
          if (this.currentSortDir === "desc") modifier = -1;
          let a = _.get(objA, this.currentSort);
          let b = _.get(objB, this.currentSort);
          if (!a) a = "";
          if (!b) b = "";
          if (a < b) return -1 * modifier;
          if (a > b) return 1 * modifier;
          return 0;
        });
    }
  },
  mounted() {
    this.constants = constants;
    api.get("/statuses").then(response => {
      this.statuses = response.status;
    });
    this.getVoids(this.date);
  },
  methods: {
    getServiceCode() {
      switch (this.void) {
        case "redeliveries":
          this.service_code = constants.REENTREGAS;
          this.label = "Reentregas";
          this.json_fields = redeliveries_fields;
          break;
        case "devolutions":
          this.service_code = constants.DEVOLUCIONES;
          this.label = "Devoluciones";
          this.json_fields = devolutions_fields;
          break;
        case "positioning":
          this.service_code = constants.POSICIONAMIENTOS;
          this.label = "Posicionamientos";
          this.json_fields = positionings_fields;
          break;
      }
      return this.service_code;
    },
    getVoids(date) {
      let data = {
        date_start: moment(date.start).format("YYYY-MM-DD 00:00:00"),
        date_end: moment(date.end).format("YYYY-MM-DD 23:59:59"),
        assigned: false,
        finish: false,
        service_code: [this.getServiceCode()]
      };

      api.post("/list_requeriments", data).then(response => {
        this.rqs = response.requeriments;
      });
    },
    detail() {
      this.$router.push(`/voids/${this.void}/detail/${this.rq.id}`);
    },
    edit() {
      console.log(this.void, "TEST");
      let route = this.$router.resolve({
        path: `/voids/${this.void}/edit/${this.rq.id}`
      });
      window.open(route.href, "_blank");
      // this.$router.push(`/voids/${this.void}/edit/${this.rq.id}`)
    },
    editService() {
      let route = this.$router.resolve({
        path: `/voids/edit/${this.rq.service_id}`
      });
      window.open(route.href, "_blank");
    },
    selectRq(rq) {
      this.rq = rq;
      this.$refs.ctxMenu.open();
    },
    searchText(text) {
      this.search = text;
    },
    changeQty(num) {
      this.numPages = num;
    },
    capitalize(s) {
      if (typeof s !== "string") return "";
      return s.charAt(0).toUpperCase() + s.slice(1);
    },
    finishService() {
      const question = `¿Seguro desea finalizar el requerimiento #${this.rq.id}`;
      if(confirm(question))
        this.updateRq(constants.FINALIZADO, "finalizado");
    },
    updateRq(status, label, subjects = null) {
      let data = {
        status_id: this.statuses.find(st => st.code === status).id,
        truck_id: null,
        driver_id: null
      };
      api.put(`/requeriments/${this.rq.id}`, data).then(response => {
        if (response.success) {
          api
            .post("/action_logs/", {
              rq_id: this.rq.id,
              comments: this.capitalize(label),
              subjects
            })
            .then(res => console.log(res));

          this.$toastr.success(`Requerimiento ${label}.`, "Requerimiento", {
            positionClass: "toast-top-center",
            closeButton: true
          });

          if (this.rq.driver_id) {
            let data_push = {
              user_id: this.rq.driver_id,
              headings: `Requerimiento ${label}`,
              contents: label,
              data: { requeriment_id: this.rq.id }
            };
            api.post("/send_push", data_push).then(response => {
              console.log(response);
            });
          }

          // this.$socket.emit("updateRequerimentServer", response.requeriment);
        }
      });
    },
    approve() {
      const status = constants.APROBADO;
      this.updateRq(status, "aprobado");
    },
    cancel() {
      const question = `¿Seguro desea anular el requerimiento #${this.rq.id}`;
      if (confirm(question)) {
        this.showModalSubjects = true;
      }
    },
    sendSubjects(subjects) {
      const status = constants.ANULADO_TRAMARSA;
      this.showModalSubjects = false;
      this.updateRq(status, "anulado", subjects);
    },
    openDoc(folder, doc) {
      const url = s3.getSignedUrl("getObject", {
        Bucket: `${process.env.VUE_APP_AWS_BUCKET}/${folder}`,
        Key: doc,
        Expires: 60
      });
      window.open(url, "_blank");
    },
    sort(s) {
      if (s === this.currentSort) {
        this.currentSortDir = this.currentSortDir === "asc" ? "desc" : "asc";
      }
      this.currentSort = s;
    }
  },
  sockets: {
    connect: function() {
      console.log("socket connected");
    },
    updateRequeriment: function(rq) {
      console.log(rq);
      const index = this.rqs.findIndex(r => r.id === rq.id);
      if (index >= 0) {
        if (!rq.truck_id) this.rqs.splice(index, 1, rq);
        else if (rq.truck_id) this.rqs.splice(index, 1);
      }
    },
    addRequeriment: function(rq) {
      if (rq.service.code === constants.REENTREGAS) {
        this.rqs.push(rq);
      }
    }
  }
};
</script>

<style scoped>
th a {
  color: #000 !important;
}
</style>
